import $ from 'jquery';
// import Anchor from '../Components/_Anchor.js';
// import Swiper from '../Components/_Slider.js';

import '../Components/_Header.js';
import '../Components/_Accordion.js';
import '../Components/_Anchor.js';
import '../Components/_Animation.js';
import '../Components/_MatchHeight.js';
import '../Components/_Slider.js';
import '../Components/_Aos.js';
import '../Components/_Modal.js';

$(window).on("load", function (e) {
  $(".c-mv1").addClass("is-ready");
})
